import {
  RECEIVE_USER_LICENSE_ASSIGNMENTS,
  RECEIVE_ENTERPRISE_LICENSE_ASSIGNMENTS,
  RECEIVE_LICENSE_ASSIGNMENT_LIST,
} from '../constants/ActionTypes';

const assignments = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_USER_LICENSE_ASSIGNMENTS:
    case RECEIVE_ENTERPRISE_LICENSE_ASSIGNMENTS:
    case RECEIVE_LICENSE_ASSIGNMENT_LIST:
      return action.payload;
    default:
      return state;
  }
}

export default assignments;



// WEBPACK FOOTER //
// ./src/reducers/assignments.js